/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      // APPS
      {title: "Home",   url: "/",             icon: "HomeIcon",     is_bookmarked: true},
      // {title: "Login",  url: "/pages/login",  icon: "LogInIcon",    is_bookmarked: true},
      // {title: "Logout", url: "/pages/logout", icon: "LogOutIcon",   is_bookmarked: true},
    ]
  },
}
/* eslint-enable */
